export const CITIES_SEARCH = "META:CITIES_SEARCH"
